import UI_BoosterButton from './UI_BoosterButton';

/* eslint-disable new-cap */
export default class UI_BoosterPanel extends Phaser.Group {
  /**
   * The booster panel on the bottom of the game screen
   * @param {Board} board
   */
  constructor(board) {
    super(game);

    this._board = board;
    this.y = game.height;

    const showLevelAsHard = G.lvlData && G.lvlData.showAsHard;
    const assetsFolder = window.assetsFolder ? window.assetsFolder : 'assets';
    this._bg = new G.Utils.NineSlice.fromJSON(
      showLevelAsHard
        ? `${assetsFolder}/board/gameplay_bottom_bar_hard`
        : `${assetsFolder}/board/gameplay_bottom_bar_normal`,
      7, 0, 627, 31,
    );
    this.add(this._bg);
    this._bg.anchor.setTo(0, 1);

    this._shadows = [
      G.makeImage(0, -20, 'bottom_ui_shadow', 0.5, this._bg),
      G.makeImage(0, -20, 'bottom_ui_shadow', 0.5, this._bg),
      G.makeImage(0, -20, 'bottom_ui_shadow', 0.5, this._bg),
      G.makeImage(0, -20, 'bottom_ui_shadow', 0.5, this._bg),
      G.makeImage(0, -20, 'bottom_ui_shadow', 0.5, this._bg),
    ];

    // Accessed externally
    this.boostersBtn = [
      this._makeBoosterBtn(290, -64, 1),
      this._makeBoosterBtn(480, -64, 2),
      this._makeBoosterBtn(860, -64, 3),
      this._makeBoosterBtn(670, -64, 4),
    ];

    // Signals
    this._signalBindings = [];
    this._signalBindings.push(G.sb('onWindowOpened').add(this.lockInput, this));
    this._signalBindings.push(G.sb('onAllWindowsClosed').add(this.unlockInput, this));
    this._signalBindings.push(G.sb('onStateChange').add(this.lockInput, this));
    this._signalBindings.push(G.sb('actionQueueEmpty').add(() => {
      if (G.lvl.goalAchieved) return;
      this._checkSuggestions();
    }));
    this._signalBindings.push(G.sb('onGoalAchieved').add(() => {
      this.boostersBtn.forEach((e) => { e.suggested = false; });
      this.lockInput();
    }));

    this._signalBindings.push(G.sb('onScreenResize').add(this._onScreenResize, this));
    this._onScreenResize();
  }

  /**
   * Destroy!
   */
  destroy() {
    if (this._signalBindings) {
      this._signalBindings.forEach((binding) => {
        if (binding.detach) {
          binding.detach();
        }
      });
      this._signalBindings = null;
    }
    super.destroy();
  }

  /**
   * Hides away
   */
  animatePositionToHidden() {
    const durationMs = 333;
    const hideDistance = this.height;
    game.add.tween(this).to({ y: game.height + hideDistance }, durationMs, Phaser.Easing.Cubic.Out, true);
  }

  /**
   * Shows up
   */
  animatePositionToVisible() {
    const durationMs = 333;
    game.add.tween(this).to({ y: game.height }, durationMs, Phaser.Easing.Cubic.Out, true);
  }

  /**
   * Repositions accordingly to the center
   */
  _onScreenResize() {
    this.y = game.height;
    this.x = 0;

    this._shadows[0].x = G.l(65);

    this.boostersBtn.forEach((e, i) => {
      e.y = e.orgY = G.l(-64);
      e.x = e.orgX = G.l(180 + (125 * i));

      this._shadows[i + 1].x = e.x - G.l(7);
    });
  }

  /**
   * Lock it so it cannot be clicked
   */
  lockInput() {
    this.boostersBtn.forEach((child) => {
      if (child.lock) child.lock();
    });
  }

  /**
   * Unlock to be clicked
   */
  unlockInput() {
    this.boostersBtn.forEach((child) => {
      if (child.unlock) {
        child.unlock();
      }
    });
  }

  /**
   * Popuplates the bar with the booster
   * @param {number} x
   * @param {number} y
   * @param {number} nr
   */
  _makeBoosterBtn(x, y, nr) {
    if (G.saveState.isBoosterUnlocked(nr)) {
      const btn = new UI_BoosterButton(x, y, nr);
      return this.add(btn);
    }
    return G.makeImage(x, y, `ui_booster_${nr}_locked`, 0.5, this);
  }

  /**
   * Check if the booster has the hand image. If it does, show it!
   * Otherwise don't
   */
  _checkSuggestions() {
    this.boostersBtn.forEach((elem, index) => {
      if (!G.lvl.goalAchieved && this[`checkBooster${(index + 1)}Suggestion`]()) {
        if (elem.showSuggestion) {
          elem.showSuggestion();
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (elem.hideSuggestion) elem.hideSuggestion();
      }
    });
  }

  /**
   * Called by the function above... But why?
   */
  checkBooster1Suggestion() {
    return false;
  }

  checkBooster2Suggestion() {
    return false;
  }

  checkBooster3Suggestion() {
    return false;
  }

  checkBooster4Suggestion() {
    return false;
  }
}
